// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/bao-router";
import "./../services/finito-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import finitoService from "./../services/finito-service";
// let finitoService = window.baorequire('Services/FinitoService');
class TaskBook extends SubscriptionViewModel {
    FormName: KnockoutObservable<string> = ko.observable();
    ReportShortTitle: KnockoutObservable<string> = ko.observable();
    ReportTitle: KnockoutObservable<string> = ko.observable();
    TaskBooks: KnockoutObservableArray<any> = ko.observableArray([]);
    SelectedTaskBookId: KnockoutObservable<string> = ko.observable();
    ShowAll: KnockoutObservable<boolean> = ko.observable();
    ShowClosedTasks: KnockoutObservable<boolean> = ko.observable();
    OnlyValidTasks: KnockoutObservable<boolean> = ko.observable();
    Tasks: KnockoutObservableArray<any> = ko.observableArray([]);
    PageSize: KnockoutObservable<number> = ko.observable(20);
    PageIndex: KnockoutObservable<number> = ko.observable(0);
    Sorting: KnockoutObservableArray<any> = ko.observableArray();
    Selection: KnockoutObservableArray<any> = ko.observableArray();
    TotalRows: KnockoutObservable<number> = ko.observable(0);
    CustomFilter: KnockoutObservable<any> = ko.observable({});
    IsFirstLoaded: KnockoutObservable<boolean> = ko.observable(false);
    TaskBooksPermissions: any;
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    Color: string = "text-warning";
    Icon: string = "fal fa-calendar-check";
    Sort: number = 20;
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SettingsKeyPermission("ShiftbookSave");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.subscribe(this.PageIndex, () => {
            if (this.IsFirstLoaded()) {
                this.RefreshTasks();
            }
        });
        this.subscribe(this.SelectedTaskBookId, () => {
            this.SetPermissions();
            this.RefreshTasks();
            this.isQuickStartModuleActive();
            baoRouter.setHash("taskbook/" + this.SelectedTaskBookId());
            this.SettingsUrl(this.SelectedTaskBookId() ? 'Shiftbook/' + this.SelectedTaskBookId() : null);
        });
        this.subscribe(this.TotalRows, () => {
            this.toggleButtons();
        });
        this.subscribe(this.TabPage.UrlData, (value) => {
            if (value.taskbookid && this.SelectedTaskBookId() != value.taskbookid && this.TaskBooks().some(b => ko.unwrap(b.ShiftbookId) == value.taskbookid)) {
                this.SelectedTaskBookId(value.taskbookid)
            }
        });
    }
    link = (index, taskModel) => {
        let linkHash = 'task/' + taskModel.InstructionId();
        baoRouter.setHash(linkHash);
    };
    init = () => {
        this.TabPage.IsLoading(true);
        return $.when(this.getUserProfile(), this.getTaskBooks()).then(() => {
            return this.getReport()
                // abschließend sicher stellen, dass die Buttons den richtigen State haben
                .then(() => {
                    this.toggleButtons();
                    this.SetPermissions();
                });
        });
    };
    loaded = () => {
        let def = $.Deferred();
        this.registerMenuClick();
        this.toggleButtons();
        Bao.bindEvent('tasks:refresh', (value) => {
            this.refresh();
        });
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        this.subscribe(this.Selection, () => {
            this.toggleButtons();
        });
        this.subscribe(this.Sorting, () => {
            this.RefreshTasks();
        });
        this.subscribe(this.CustomFilter, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.ShowClosedTasks, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.OnlyValidTasks, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.PageSize, () => {
            this.ResetPageIndexAndRefresh();
        });
       
        def.resolve();
        return def.promise();
    };
    ToHashObject = (customFilter) => {
        let returnValue = [];
        for (let f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    };
    // Fetch UserProfile
    getUserProfile = () => {
        return Bao.post('TaskBook/LoadUserProfile', JSON.stringify({})).then((result) => {
            this.OnlyValidTasks(result.onlyShowValidTasks === "true" ? true : false);
            this.ShowClosedTasks(result.showClosedTasks === "true" ? true : false);
        });
    };
    getTaskBooks = () => {
        return Bao.post('Shiftbook/GetTaskBooksForCurrentUser')
            .then(serverResult => {
                if (serverResult.TaskBooksForCurrentUser.length > 0) {
                    this.TaskBooks(serverResult.TaskBooksForCurrentUser);
                    this.TaskBooksPermissions = serverResult.ShiftbooksPermissions;
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedTaskBooks"), "info");
                    this.TabPage.IsLoading(false);
                }
                let taskBookId = baoRouter.getRouteValue("taskbookid", (<any>this.TabPage));
                if (taskBookId && serverResult.TaskBooksForCurrentUser.filter(t => t.ShiftbookId === taskBookId).length > 0) {
                    this.SelectedTaskBookId(taskBookId);
                }
            });
    };
    //
    // Menü-ClickHandler
    registerMenuClick = () => {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                let methodString = btn.ActionKey().substr(this.FormName().length);
                if (methodString) {
                    methodString = methodString.toLowerCase();
                    if ($.isFunction(this[methodString])) {
                        this[methodString]();
                    }
                }
            }
        });
    };
    //
    // Fetch Report
    getReport = () => {
        return Bao.post('TaskBook/GetTaskBookModel', JSON.stringify({})).then((result) => {
            ko.map.fromJS(result.Model, this);
            this.TabPage.Title(this.ReportShortTitle());
            (<any>this.TabPage).ToolTip(this.ReportTitle());
        });
    };
    /** calls getTasks and handles IsLoading */
    RefreshTasks() {
        this.TabPage.IsLoading(true);
        this.getTasks()
            .then(() => {
                this.TabPage.IsLoading(false);
            });
    }
    //
    // Fetch Tasks
    getTasks = () => {
        if (!this.SelectedTaskBookId()) {
            return;
        }
        let customFilter = this.ToHashObject(ko.unwrap(this.CustomFilter));
        return Bao.post('TaskBook/GetAll', JSON.stringify({
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            searchFilter: {
                ShowAll: this.ShowAll(),
                ShowClosedTasks: this.ShowClosedTasks(),
                OnlyValidTasks: this.OnlyValidTasks(),
                ShiftbookId: this.SelectedTaskBookId()
            },
            customfilter: customFilter
        })).then((result) => {
            ko.map.fromJS(result.Models, this.Tasks);
            this.TotalRows(result.TotalRows);
            this.IsFirstLoaded(true);
        });
    };
    //
    // Buttons ein-/ausblenden
    toggleButtons = () => {
        if (this.SelectedTaskBookId()) {
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: true, Context: this.TabPage.Context() });
        }
        else {
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: false, Context: this.TabPage.Context() });
        }
        if (this.TotalRows() < 1) {
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'InProgress', Enabled: false, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Finish', Enabled: false, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: false, Context: this.TabPage.Context() });
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Approve', Enabled: false, Context: this.TabPage.Context() });
        }
        else {
            let selection = this.Selection();
            BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: true, Context: this.TabPage.Context() });
            if (selection && selection.length > 0) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: true, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: !selection[0].IsPublished.peek(), Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'InProgress', Enabled: !selection[0].IsClosed.peek() && selection[0].CanEditBasedOnApproval.peek(), Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Finish', Enabled: !selection[0].IsClosed.peek() && selection[0].CanEditBasedOnApproval.peek(), Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Approve', Enabled: this.canApprove(selection[0]), Context: this.TabPage.Context() });
            }
            else {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'InProgress', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Finish', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Approve', Enabled: false, Context: this.TabPage.Context() });
            }
        }
    };
    //
    // Aufgabe erstellen
    ["new"] = () => {
        let linkHash = 'task/' + Guid() + '/' + this.SelectedTaskBookId();
        baoRouter.setHash(linkHash);
    };
    //
    // Aufgabe bearbeiten
    edit = () => {
        let selection = this.Selection();
        if (selection && selection.length > 0) {
            baoRouter.setHash('task/' + selection[0].InstructionId());
        }
    };

    //
    // Aufgabe in Bearbeitung
    inprogress = () => {
        let selection = this.Selection();
        if (selection && selection.length > 0) {
            let dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.TaskInProgressQuestion), 'yesno');
            dialog.DialogResult.subscribe((shouldInProgress) => {
                if (shouldInProgress) {
                    this.TabPage.IsLoading(true);
                    Bao.post('Task/InProgress', JSON.stringify({
                        taskIds: [selection[0].InstructionId()]
                    })).then((inProgress) => {
                        if (inProgress > 0) {
                            this.refresh();
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };

    //
    // Aufgabe erledigen
    finish = () => {
        let selection = this.Selection();
        if (selection && selection.length > 0) {
            let dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.TaskFinishQuestion), 'yesno');
            dialog.DialogResult.subscribe((shouldFinish) => {
                if (shouldFinish) {
                    this.TabPage.IsLoading(true);
                    Bao.post('Task/Finish', JSON.stringify({
                        taskIds: [selection[0].InstructionId()]
                    })).then((finished) => {
                        if (finished > 0) {
                            this.refresh();
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    //Aufgabe genehmigen
    approve = () => {
        var selection = this.Selection();
        return Bao.post("Task/TaskApprovalDialog", JSON.stringify({}), result => {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            dialog.ViewModel(self);
            var approveButton = new BaoDialogViewModel.ButtonFactory(dialog, Bao.Session.GetMessage("msgApprove"), () => {
                this.TabPage.IsLoading(true);
                Bao.post('Task/Approve', JSON.stringify({
                    taskId: selection[0].InstructionId()
                })).then(approved => {
                    if (approved > 0) {
                        this.showAlert(finitoService.MessageKeys.TaskApproveSuccessful);
                        this.refresh();
                    }
                    else {
                        this.showAlert(finitoService.MessageKeys.TaskApproveError, 'info');
                    }
                    this.TabPage.IsLoading(false);
                });
                dialog.Close();
            });
            var rejectButton = new BaoDialogViewModel.ButtonFactory(dialog, Bao.Session.GetMessage("msgReject"), () => {
                this.TabPage.IsLoading(true);
                Bao.post('Task/Reject', JSON.stringify({
                    taskId: selection[0].InstructionId()
                })).then(rejected => {
                    if (rejected > 0) {
                        this.showAlert(finitoService.MessageKeys.TaskRejectSuccessful);
                        this.refresh();
                    }
                    else {
                        this.showAlert(finitoService.MessageKeys.TaskRejectError, 'info');
                    }
                    this.TabPage.IsLoading(false);
                });
                dialog.Close();
            });
            var cancelButton = new BaoDialogViewModel.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            dialog.Buttons([approveButton, rejectButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open();
        });
    };
    canApprove = (task) => {
        if (task) {
            if (!task.IsClosed.peek()) {
                if (task.IsApprover.peek() && task.IsWaitForApproval.peek()) {
                    return true;
                }
            }
        }
        return false;
    };
    //
    // Aufgabe löschen
    ["delete"] = () => {
        let selection = this.Selection();
        if (selection && selection.length > 0) {
            let dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.TaskDeleteQuestion), 'yesno');
            dialog.DialogResult.subscribe((canDelete) => {
                if (canDelete) {
                    this.TabPage.IsLoading(true);
                    return Bao.post('Task/Delete', JSON.stringify({
                        taskIds: [selection[0].InstructionId()]
                    })).then((deleted) => {
                        this.Selection([]);
                        if (deleted > 0) {
                            this.showAlert(finitoService.MessageKeys.TaskDeleteSuccessful);
                            this.refresh();
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.TaskDeleteError, 'danger');
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    //
    // Aktualisieren
    refresh = () => {
        this.RefreshTasks();
    };
    //
    // Drucken
    print = () => {
        this.TabPage.IsLoading(true);
        Bao.post("TaskBook/Print", JSON.stringify({
            showClosed: this.ShowClosedTasks(),
            shiftbookId: this.SelectedTaskBookId()
        }), (result) => {
            this.TabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    };
    /**
     * Get the permissions object for the current selected taskbook
     * */
    GetCurrentTaskBooksPermissions() {
        if (this.SelectedTaskBookId() && this.TaskBooksPermissions) {
            return this.TaskBooksPermissions[this.SelectedTaskBookId()];
        }
        return null;
    }
    /**
     * Shows/Hides toolbarbuttons for the current taskbookpermissions (RoleShiftbooks)
     * */
    SetPermissions() {
        let permissions = this.GetCurrentTaskBooksPermissions();
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: permissions[actionKey] });
            if (actionKey === "TaskReportShowAll") {
                this.ShowAll(permissions[actionKey]);
            }
        }
    }
    ResetPageIndexAndRefresh() {
        if (this.PageIndex() === 0) {
            this.RefreshTasks();
        }
        else {
            this.PageIndex(0);
        }
    }
    ;
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        var selectedTaskBook = this.TaskBooks().
            filter(e => e.PrimaryKeyValue === this.SelectedTaskBookId());
        var TaskBookName = selectedTaskBook[0].Name;
        var TaskBookCssClass = selectedTaskBook[0].CssClass;
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: TaskBookName,
            caption2: TaskBookName,
            caption3: TaskBookName,
            caption4: TaskBookName,
            caption5: TaskBookName,
            webUrl: this.GetTaskBookDeepLink(),
            color: this.Color,
            icon: (typeof TaskBookCssClass != 'undefined' && TaskBookCssClass) ? TaskBookCssClass : this.Icon,
            sort: this.Sort
        }))
            .done(result => {
                if (result) {
                    this.IsFavorite(true);
                }
                this.TabPage.IsLoading(false);
            });
    };
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetTaskBookDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetTaskBookDeepLink()
        }))
            .done(result => {
                if (result) {
                    this.IsFavorite(false);
                }
                this.TabPage.IsLoading(false);
            });
    };
    GetTaskBookDeepLink() {
        return "#/TaskBook/" + this.SelectedTaskBookId();
    }
}
export default TaskBook;